// NOTICE: KAPTION-INTEGRATION — team-location.SETTINGS.2
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import store from 'dashboard/store';
import {
  buildTeamLocationRouteGuard,
  isTeamLocationEnabledForAccount,
} from 'dashboard/helper/kaptionTeamLocationAvailability';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/team-location'),
      component: SettingsWrapper,
      // team-location.HIDDEN.4 — disabled for the account → dashboard.
      beforeEnter: buildTeamLocationRouteGuard(
        isTeamLocationEnabledForAccount,
        () => store
      ),
      children: [
        {
          path: '',
          name: 'settings_kaption_team_location',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
